import { useEffect, useState } from "react";

/**
 * Resumen del Chat Elite para el staff (contadores del menu y del panel), compartido entre
 * componentes sin Context: lo actualiza AvisosChatEliteStaff y lo leen el menu y el panel.
 */
let resumen = null;
const suscriptores = new Set();

export const setResumenChatEliteStaff = (nuevo) => {
  resumen = nuevo;
  suscriptores.forEach((fn) => fn(resumen));
};

export const getResumenChatEliteStaff = () => resumen;

/**
 * Numero que se muestra en el menu: lo que requiere accion.
 * ADMIN/CONSUL: sin asignar + mis tickets con mensajes sin leer. VENT: tickets en espera.
 */
export const contadorMenuChatElite = (r, esLectura = false) => (esLectura
  ? r?.bandejas?.en_espera || 0
  : (r?.sinAsignar || 0) + (r?.noLeidosMios || 0));

const useResumenChatEliteStaff = () => {
  const [valor, setValor] = useState(resumen);
  useEffect(() => {
    suscriptores.add(setValor);
    setValor(resumen);
    return () => suscriptores.delete(setValor);
  }, []);
  return valor;
};

export default useResumenChatEliteStaff;
